export function handleSidebarEvents() {
    $("body").on('click', '.js-toggle-nav', () => {
        $('body').toggleClass('nav-active');

        return false;
    }).on('click', '.js-close-nav', () => {
        $('body').removeClass('nav-active');

        return false;
    });

    $(window).on("resize", updateSidebarSticky);
    updateSidebarSticky();

}

function updateSidebarSticky() {
    $(".sidebar").toggleClass("sidebar--sticky", $(".sidebar__wrapper").outerHeight() <= $(window).outerHeight());
}
